import { Grid, Stack } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import { FormInternalLinks } from 'components/FormLinks';
import { UrgencySelector } from 'features/geoEvents/components/UrgencySelector';
import { ReporterNotesFormSection } from 'features/reporterNotes/components/ReporterNotesFormSection';

type InternalFormSectionProps = {
  geoEventId?: number;
  newReporterNoteInitialValue: string;
  showUrgency?: boolean;
  canEditUrgency?: boolean;
  showInternalLinks?: boolean;
};

export const InternalFormSection = (
  props: InternalFormSectionProps,
): JSX.Element => {
  const {
    geoEventId,
    newReporterNoteInitialValue,
    showUrgency = false,
    canEditUrgency = true,
    showInternalLinks = false,
  } = props;
  const { formState } = useFormContext();

  return (
    <Stack spacing={4}>
      {showUrgency && (
        <UrgencySelector disabled={!canEditUrgency || formState.isSubmitting} />
      )}

      <ReporterNotesFormSection
        geoEventId={geoEventId}
        newReporterNoteInitialValue={newReporterNoteInitialValue}
      />

      {/* FormInternalLinks expects a Grid parent, when we remove the internal_tab_on_incidents flag, we can clean */}
      {/* this up in the component and remove the wrapper */}
      {showInternalLinks && (
        <Grid container spacing={2}>
          <FormInternalLinks />
        </Grid>
      )}
    </Stack>
  );
};
